import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PPUBypassSupervisorModel, PPUPickupPaymentModel } from '@app/shared/models/deliver-customer.model';
import { DeliverCustomerService } from '@app/shared/services/deliver-customer.service';
import { PPUAlertService } from '@app/shared/services/ppu-alert.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-bypass-payment',
  templateUrl: './bypass-payment.component.html',
  standalone: false,
})
export class BypassPaymentComponent {
  public bypassPaymentForm!: FormGroup;
  public supervisorBypassResult: PPUBypassSupervisorModel | undefined;

  constructor(
    private dialogRef: MatDialogRef<BypassPaymentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PPUPickupPaymentModel,
    private translateService: TranslateService,
    private ppuAlertService: PPUAlertService,
    private deliverCustomerService: DeliverCustomerService,
    private formBuilder: FormBuilder
  ) {
    this.dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.bypassPaymentForm = this.formBuilder.group({
      supervisorCode: ['', [Validators.required]],
    });
  }

  bypassPayment() {
    this.deliverCustomerService
      .verifySupervisorCode(this.bypassPaymentForm.get('supervisorCode')?.value, this.data.orderIds)
      .subscribe({
        next: (result: PPUBypassSupervisorModel) => {
          this.supervisorBypassResult = result;
          if (result.isSupervisorValidated) {
            this.ppuAlertService.successEvent(
              this.translateService.instant('App.RequestPayment.Messages.BypassSuccess')
            );
            this.closeBypassPayment();
          } else {
            this.ppuAlertService.errorEvent(this.translateService.instant('App.RequestPayment.Messages.BypassFail'));
          }
        },
        error: (error) => {
          this.ppuAlertService.errorEvent(error[0]);
        },
      });
  }

  closeBypassPayment() {
    this.dialogRef.close(this.supervisorBypassResult);
  }
}
